/* eslint-disable */
(function() {
  var $ = require('jquery');

  if (!$('body').hasClass('IE8')) {
    // Listen for orientation changes
    //fixes bug on ipad
    window.addEventListener('orientationchange', function() {
      $('body').fadeOut(1, function() {
        $('body').fadeIn(1);
      });
    });

    horizontalDetect();

    //if not ipad or iphone
    if (!isiPad() && !isiPhone()) {
      $('body').addClass('everything-else');
    }

    if (isiPad()) {
      $('body').addClass('iPad');

      if (window.orientation === 90) {
        $('body').addClass('iPad-horizontal');
        $('body').removeClass('iPad-vertical');
      } else {
        $('body').removeClass('iPad-horizontal');
        $('body').addClass('iPad-vertical');
      }

      // Listen for orientation changes
      window.addEventListener(
        'orientationchange',
        function() {
          // Announce the new orientation number
          if (window.orientation === 90) {
            $('body').addClass('iPad-horizontal');
          } else {
            $('body').removeClass('iPad-horizontal');
          }
        },
        false,
      );
    }

    if (isiPhone()) {
      $('body').addClass('iPhone');
      //if ($(window).height() <= 480)
      // {
      //    $('body').addClass('iPhone4');
      //}

      if (window.orientation === 90) {
        $('body').addClass('iPhone-horizontal');
      } else {
        $('body').removeClass('iPhone-horizontal');
      }

      // Listen for orientation changes
      window.addEventListener(
        'orientationchange',
        function() {
          // Announce the new orientation number
          if (window.orientation === 90) {
            $('body').addClass('iPhone-horizontal');
          } else {
            $('body').removeClass('iPhone-horizontal');
          }
        },
        false,
      );
    }

    $(window).resize(function() {
      horizontalDetect();

      if ($(window).innerWidth() > 767) {
        if ($('body').hasClass('iPhone-horizontal')) {
          $('body').removeClass('iPhone-horizontal');
        }
        if ($('body').hasClass('iPad-horizontal')) {
          $('body').removeClass('iPad-horizontal');
        }
      } else {
        if (isiPhone()) {
          if (!$('body').hasClass('iPhone')) {
            $('body').addClass('iPhone');
          }

          if (window.orientation === 90) {
            $('body').addClass('iPhone-horizontal');
          } else {
            $('body').removeClass('iPhone-horizontal');
          }
        }

        if (isiPad()) {
          if (!$('body').hasClass('iPad')) {
            $('body').addClass('iPad');
          }

          if (window.orientation === 90) {
            $('body').addClass('iPad-horizontal');
            $('body').removeClass('iPad-vertical');
          } else {
            $('body').removeClass('iPad-horizontal');
            $('body').addClass('iPad-vertical');
          }
        }
      }
    });
  }

  //generic device landscape
  function horizontalDetect() {
    if ($(window).innerWidth() < 992) {
      var viewHeight = $(window).height();
      var viewWidth = $(window).width();

      if (viewWidth > viewHeight) {
        if (!$('body').hasClass('landscape')) {
          $('body').addClass('landscape');
        }
      } else {
        if ($('body').hasClass('landscape')) {
          $('body').removeClass('landscape');
        }
      }
    }
  }

  // iDevices -- Return boolean TRUE/FALSE
  function isiPhone() {
    return navigator.platform.indexOf('iPhone') !== -1 || navigator.platform.indexOf('iPod') !== -1;
  }

  function isiPad() {
    return navigator.platform.indexOf('iPad') !== -1;
  }
})();
